export const folderAccessKeys = {
  folder_access_list: () => ['FOLDER_ACCESS_LIST'] as const,
  folder_access_update: (folderId: number) =>
    [...folderAccessKeys.folder_access_list(), folderId] as const,
};
